document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('quiz-app-root');
  const configScript = document.getElementById('quiz-config');
  const settingsScript = document.getElementById('quiz-settings');

  if (!root || !configScript || !settingsScript) return;

  let quizData = null;
  let settings = {};

  try {
    settings = JSON.parse(settingsScript.textContent);
  } catch (e) {
    console.warn('Quiz settings parse error:', e, '\nRaw settings:', settingsScript.textContent);
    settings = {};
  }

  try {
    quizData = JSON.parse(configScript.textContent);
  } catch (e) {
    console.error('Quiz config parse error:', e, '\nRaw config:', configScript.textContent);
    root.innerHTML = '<p class="quiz-error">Error parsing quiz configuration. Check browser console.</p>';
    return;
  }

  // Handle stringified JSON (multi-line text metafield)
  if (typeof quizData === 'string') {
    try {
      quizData = JSON.parse(quizData);
    } catch (err) {
      console.warn('Quiz inner parse error', err, '\nInner raw config:', quizData);
    }
  }

  if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
    console.error('Quiz data is missing or not an array. Current value:', quizData);
    root.innerHTML = `
      <div class="quiz-error">
        <h3>Quiz Configuration Missing</h3>
        <p>Please double check the following in your Shopify Admin:</p>
        <ol style="text-align:left; max-width:500px; margin:0 auto; padding-left:20px;">
          <li>You created a Metafield on <strong>Pages</strong> (not Products or Shop).</li>
          <li>The Namespace and key is exactly: <code>custom.quiz_data</code>.</li>
          <li>You filled out the JSON data on the specific Page in the "Online Store > Pages" section.</li>
        </ol>
      </div>
    `;
    return;
  }

  // Read Q1 option images (uploaded via Theme Customizer)
  // Array of 3 URLs (or nulls if not uploaded yet).
  let q1Images = [];
  try {
    const q1El = document.getElementById('quiz-q1-images');
    if (q1El) q1Images = JSON.parse(q1El.textContent) || [];
  } catch (e) {
    q1Images = [];
  }

  // Read Q2 option images (uploaded via Theme Customizer)
  // Array of 4 URLs (or nulls if not uploaded yet).
  let q2Images = [];
  try {
    const q2El = document.getElementById('quiz-q2-images');
    if (q2El) q2Images = JSON.parse(q2El.textContent) || [];
  } catch (e) {
    q2Images = [];
  }

  // Read Q3 helper text (one text per option).
  let q3Subtexts = [];
  try {
    const q3El = document.getElementById('quiz-q3-subtexts');
    if (q3El) q3Subtexts = JSON.parse(q3El.textContent) || [];
  } catch (e) {
    q3Subtexts = [];
  }

  // Step index map (0-based)
  const Q1_STEP = 0;
  const Q2_STEP = 1;
  const Q3_STEP = 2;

  let currentStep = 0;
  const answers = {};
  let autoAdvanceTimer = null;
  let quizStarted = false; // track first render to skip auto-scroll on load

  const leadGate = Object.assign({
    gateIcon: null,
    gateEyebrow: 'ALMOST THERE',
    gateTitle: 'Join our newsletter for exclusive discounts',
    emailPlaceholder: 'Enter email address for savings',
    submitLabel: 'SUBMIT AND SEE RESULTS',
    noThanksLabel: 'No Thanks',
    invalidEmailText: 'Please enter a valid email address.',
    subscriberTag: 'Quiz Kit App Subscriber',
    couponIcon: null,
    couponEyebrow: 'HERE YOU GO!',
    couponTitle: 'Save the code CPQUIIZ20 and use at checkout. Cannot be combined with other offers. Exclusions may apply.',
    couponCode: 'CPQUIIZ20',
    copyLabel: 'Copy',
    copiedLabel: 'Copied',
    viewResultsLabel: 'SEE RESULTS'
  }, settings && settings.leadGate ? settings.leadGate : {});

  /* ----------------------------------------------------------
     Render the current step
  ---------------------------------------------------------- */
  function renderStep() {
    // Cancel any pending auto-advance from the previous step
    if (autoAdvanceTimer) {
      clearTimeout(autoAdvanceTimer);
      autoAdvanceTimer = null;
    }

    const step = quizData[currentStep];
    const isFirst = currentStep === 0;
    const isLast = currentStep === quizData.length - 1;
    const isSingle = step.type !== 'multiple';
    const progressPct = Math.round(((currentStep + 1) / quizData.length) * 100);

    const imageSources = currentStep === Q1_STEP
      ? q1Images
      : currentStep === Q2_STEP
        ? q2Images
        : [];
    // Q1/Q2 show image cards when at least one image is uploaded
    const useImageCards = imageSources.some(Boolean);

    // Pre-compute saved answers so we can bake `checked` straight into the
    // HTML string. This is more reliable than post-render el.checked = true
    // because the CSS :checked pseudo-class is guaranteed to match on first paint.
    const savedValues = (answers[currentStep] && Array.isArray(answers[currentStep].value))
      ? answers[currentStep].value
      : [];

    const renderOptions = (currentStep === Q2_STEP && useImageCards)
      ? buildQ2Options(step.options, imageSources.length)
      : step.options;

    const optionsHtml = renderOptions.map((opt, idx) => {
      const products   = opt.products ? opt.products.join(',') : '';
      const inputType  = isSingle ? 'radio' : 'checkbox';
      const isChecked  = savedValues.includes(opt.value);

      const subtext = currentStep === Q3_STEP ? (q3Subtexts[idx] || '') : '';
      const hideImageCardText = currentStep === Q2_STEP;
      const subtextHtml = subtext
        ? `<span class="quiz-option-subtext">${escapeHtml(String(subtext))}</span>`
        : '';

      if (useImageCards) {
        const imgUrl = imageSources[idx] || null;
        if (currentStep === Q2_STEP && !imgUrl) return '';
        return `
          <label class="quiz-option quiz-option--image-card">
            <input
              type="${inputType}"
              name="step-${currentStep}"
              value="${opt.value}"
              data-products="${products}"
              ${isChecked ? 'checked' : ''}
            >
            <div class="quiz-option-content">
              <div class="quiz-option-img-wrap">
                ${imgUrl
                  ? `<img
                      class="quiz-option-img"
                      src="${imgUrl}"
                      alt="${opt.label || `Question 2 option ${idx + 1}`}"
                      loading="lazy"
                      width="240"
                      height="240"
                    >`
                  : '<div class="quiz-option-img-placeholder"></div>'
                }
                <span class="quiz-option-img-check" aria-hidden="true">✓</span>
              </div>
              <span class="quiz-option-label-wrap">
                ${hideImageCardText ? '' : `<span class="quiz-option-label">${opt.label}</span>`}
                ${hideImageCardText ? '' : subtextHtml}
              </span>
            </div>
          </label>
        `;
      }

      // Default text-only option
      return `
        <label class="quiz-option">
          <input
            type="${inputType}"
            name="step-${currentStep}"
            value="${opt.value}"
            data-products="${products}"
            ${isChecked ? 'checked' : ''}
          >
          <div class="quiz-option-content">
            <span class="quiz-option-checkmark" aria-hidden="true"></span>
            <span class="quiz-option-label-wrap">
              <span class="quiz-option-label">${opt.label}</span>
              ${subtextHtml}
            </span>
          </div>
        </label>
      `;
    }).join('');

    root.innerHTML = `
      <div
        class="quiz-step active fadeIn"
        data-step-type="${isSingle ? 'single' : 'multiple'}"
      >
        <div class="quiz-step-content">
          <div class="quiz-progress-wrap">
            <div class="quiz-progress-top">
              <span class="quiz-progress-label">Step ${currentStep + 1} of ${quizData.length}</span>
              <span class="quiz-step-type-hint">${isSingle ? 'Select one' : 'Select all that apply'}</span>
            </div>
            <div
              class="quiz-progress-track"
              role="progressbar"
              aria-valuenow="${currentStep + 1}"
              aria-valuemin="1"
              aria-valuemax="${quizData.length}"
              aria-label="Quiz progress: step ${currentStep + 1} of ${quizData.length}"
            >
              <div class="quiz-progress-fill" style="width: ${progressPct}%"></div>
            </div>
          </div>

          <h2 class="quiz-question" id="quiz-question-${currentStep}">${step.question}</h2>

          <div
            class="quiz-options${useImageCards ? ' quiz-options--image-grid' : ''}${currentStep === Q1_STEP ? ' quiz-options--q1' : ''}${currentStep === Q2_STEP ? ' quiz-options--q2' : ''}"
            role="${isSingle ? 'radiogroup' : 'group'}"
            aria-labelledby="quiz-question-${currentStep}"
          >
            ${optionsHtml}
          </div>

          <div
            class="quiz-error-message"
            id="quiz-error-msg"
            role="alert"
            aria-live="assertive"
            style="display: none;"
          >
            ⚠ Please select an option to continue.
          </div>
        </div>
      </div>

      <div class="quiz-actions" role="group" aria-label="Quiz navigation">
        ${!isFirst
          ? '<button type="button" id="quiz-prev-btn" class="btn btn--secondary quiz-btn" aria-label="Go to previous question">Back</button>'
          : '<span aria-hidden="true"></span>'
        }
        ${isLast
          ? '<span aria-hidden="true"></span>'
          : '<button type="button" id="quiz-next-btn" class="btn btn--primary quiz-btn" aria-label="Go to next question">Next</button>'
        }
      </div>
    `;

    // Bind navigation buttons
    const prevBtn   = root.querySelector('#quiz-prev-btn');
    const nextBtn   = root.querySelector('#quiz-next-btn');

    if (prevBtn)   prevBtn.addEventListener('click', goPrev);
    if (nextBtn)   nextBtn.addEventListener('click', () => {
      if (autoAdvanceTimer) { clearTimeout(autoAdvanceTimer); autoAdvanceTimer = null; }
      goNext();
    });

    // Bind option change events
    const inputs = root.querySelectorAll(`input[name="step-${currentStep}"]`);
    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        // Hide error on any selection
        const errorEl = document.getElementById('quiz-error-msg');
        if (errorEl) errorEl.style.display = 'none';

        // Auto-advance on single-select for intermediate steps
        if (isSingle && !isLast) {
          if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
          autoAdvanceTimer = setTimeout(() => {
            autoAdvanceTimer = null;
            goNext();
          }, 380);
        }

        // Last single-select step (e.g. Question 7): go directly to email gate
        if (isSingle && isLast) {
          if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
          autoAdvanceTimer = setTimeout(() => {
            autoAdvanceTimer = null;
            submitQuiz();
          }, 260);
        }
      });
    });

    // Scroll to quiz top on step changes — but NOT on the very first render
    // so the page loads naturally from the top
    if (quizStarted) {
      scrollToQuiz();
    } else {
      quizStarted = true;
    }
  }

  /* ----------------------------------------------------------
     Scroll so the progress bar + hint is the first thing visible.
     Uses scrollIntoView on the progress-wrap element directly.
     CSS `scroll-margin-top` handles any fixed/sticky header offset.
  ---------------------------------------------------------- */
  function scrollToQuiz() {
    const target = root.querySelector('.quiz-progress-wrap');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ----------------------------------------------------------
     Read the currently checked option(s)
  ---------------------------------------------------------- */
  function getSelectedOption() {
    const selected = Array.from(
      root.querySelectorAll(`input[name="step-${currentStep}"]:checked`)
    );
    if (selected.length === 0) return null;

    const values = [];
    let products = [];
    selected.forEach((s) => {
      values.push(s.value);
      if (s.dataset.products) {
        products = products.concat(s.dataset.products.split(',').filter(Boolean));
      }
    });
    return { value: values, products };
  }

  /* ----------------------------------------------------------
     Navigation helpers
  ---------------------------------------------------------- */
  function goNext() {
    const selected = getSelectedOption();
    if (!selected) {
      const errorEl = document.getElementById('quiz-error-msg');
      if (errorEl) errorEl.style.display = 'flex';
      return;
    }
    answers[currentStep] = selected;
    currentStep++;
    renderStep();
  }

  function goPrev() {
    if (autoAdvanceTimer) {
      clearTimeout(autoAdvanceTimer);
      autoAdvanceTimer = null;
    }
    currentStep--;
    renderStep();
  }

  /* ----------------------------------------------------------
     Submit and redirect
  ---------------------------------------------------------- */
  function submitQuiz() {
    const selected = getSelectedOption();
    if (!selected) {
      const errorEl = document.getElementById('quiz-error-msg');
      if (errorEl) errorEl.style.display = 'flex';
      return;
    }
    answers[currentStep] = selected;

    // Build recommendation buckets
    let reco1 = [];
    let reco2 = [];

    // Q3 (idx 2) and Q4 (idx 3) → Reco 1 (Care & Treat)
    if (answers[2] && answers[2].products) reco1 = reco1.concat(answers[2].products);
    if (answers[3] && answers[3].products) reco1 = reco1.concat(answers[3].products);

    // Q6 (idx 5) and Q7 (idx 6) → Reco 2 (Style & Finish)
    if (answers[5] && answers[5].products) reco2 = reco2.concat(answers[5].products);
    if (answers[6] && answers[6].products) reco2 = reco2.concat(answers[6].products);

    reco1 = [...new Set(reco1)].filter((p) => p && p.trim() !== '');
    reco2 = [...new Set(reco2)].filter((p) => p && p.trim() !== '' && !reco1.includes(p));

    let bucket3 = [];

    const fallbackPool = [
      'clear-it-up-shampoo',
      'essential-leave-in',
      'plush-locks-leave-in-smooth',
      'humidity-rx®-style-lock-spraynet-wt-poids-net-165-ml-5-oz',
      'all-around®-working-hairspray-1',
      'smooth-drops',
      'instant-reboot-treatment-masque',
      'moisture-shampoo',
      'moisture-conditioner',
      'volume-shampoo',
      'volume-conditioner',
      'biorepair-thicken-shampoo',
      'biorepair-thicken-conditioner',
      'pre-tox-spray',
      'weekly-blonde-masque',
      'daily-blonde-conditioner',
      'baobab-recovery-treatment-spray',
      'lift-it-mousse',
      'texture-charge®-defining-finishing-spray',
      'fiber-blast-texture-creme',
      'tru-curl-enhancing-creme',
      'rule-breaker®-defining-wax',
      'volume-blow-dry-spray'
    ];

    const uniquePool = [...new Set(fallbackPool)].filter((p) => p && p.trim() !== '');
    reco1 = fillBucket(reco1, 3, [], uniquePool);
    reco2 = fillBucket(reco2, 3, reco1, uniquePool);
    bucket3 = fillBucket(bucket3, 4, [...reco1, ...reco2], uniquePool);

    const params = new URLSearchParams();
    if (reco1.length > 0) params.set('reco1', reco1.join(','));
    if (reco2.length > 0) params.set('reco2', reco2.join(','));
    if (bucket3.length > 0) params.set('reco3', bucket3.join(','));

    const baseResultUrl = resolveResultUrl();
    const separator = baseResultUrl.includes('?') ? '&' : '?';
    const resultUrl = baseResultUrl + separator + params.toString();
    persistQuizResultUrl(resultUrl);
    renderLeadCaptureStep(resultUrl);
  }

  function renderLeadCaptureStep(resultUrl) {
    // Hide the quiz and reveal the Liquid-rendered lead gate (which contains
    // a real {% form 'customer' %} — the form will post natively to /contact
    // when the user clicks submit, reload the page, and Shopify will create
    // the customer + add the subscriber tag.
    const leadgate = document.getElementById('quiz-leadgate-container');
    if (!leadgate) {
      // No leadgate rendered — just go to the result page.
      window.location.href = resultUrl;
      return;
    }

    if (root) root.style.display = 'none';
    leadgate.hidden = false;

    bindLeadGateActions(leadgate, resultUrl);
    scrollToLeadGate(leadgate);
  }

  function bindLeadGateActions(leadgate, resultUrl) {
    const noThanksBtn = leadgate.querySelector('#quiz-no-thanks-btn');
    if (noThanksBtn && !noThanksBtn.dataset.bound) {
      noThanksBtn.dataset.bound = '1';
      noThanksBtn.addEventListener('click', () => {
        window.location.href = resultUrl;
      });
    }

    // Re-save the result URL just before submit so the post-reload coupon
    // step always has the latest value to redirect to.
    const newsletterForm = leadgate.querySelector('#quiz_newsletter_form');
    if (newsletterForm && !newsletterForm.dataset.bound) {
      newsletterForm.dataset.bound = '1';
      newsletterForm.addEventListener('submit', () => {
        persistQuizResultUrl(resultUrl);
        const emailInput = newsletterForm.querySelector('input[type="email"]');
        if (emailInput && emailInput.value.trim()) {
          sendQuizAnswersToKlaviyo(emailInput.value.trim(), answers);
        }
      });
    }
  }

  function scrollToLeadGate(leadgate) {
    try {
      leadgate.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) { /* noop */ }
  }

  function renderCouponStep(resultUrl) {
    // Make sure the lead gate is hidden and the quiz container is visible
    // so we can render the coupon inside it.
    const leadgate = document.getElementById('quiz-leadgate-container');
    if (leadgate) leadgate.hidden = true;
    if (root) root.style.display = '';

    const code         = escapeHtml(String(leadGate.couponCode || ''));
    const eyebrow      = escapeHtml(String(leadGate.couponEyebrow || ''));
    const description  = escapeHtml(String(leadGate.couponTitle || ''));
    const copyLabel    = escapeHtml(String(leadGate.copyLabel || 'Copy'));
    const copiedLabel  = escapeHtml(String(leadGate.copiedLabel || 'Copied'));
    const ctaLabel     = escapeHtml(String(leadGate.viewResultsLabel || ''));
    const customIcon   = leadGate.couponIcon
      ? `<img class="quiz-coupon-header__icon" src="${leadGate.couponIcon}" alt="" loading="lazy" width="48" height="48">`
      : '';

    root.innerHTML = `
      <section class="quiz-coupon-stage" aria-label="Your coupon code">
        <div class="quiz-coupon-burst" aria-hidden="true">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </div>

        <header class="quiz-coupon-header">
          ${customIcon}
          <p class="quiz-coupon-eyebrow">
            <span class="quiz-coupon-eyebrow__rule" aria-hidden="true"></span>
            <span class="quiz-coupon-eyebrow__text">${eyebrow}</span>
            <span class="quiz-coupon-eyebrow__rule" aria-hidden="true"></span>
          </p>
          <h2 class="quiz-coupon-title">${description}</h2>
        </header>

        <div class="quiz-coupon-voucher-wrap">
          <article class="quiz-coupon-voucher" role="group" aria-label="Discount voucher">
            <span class="quiz-coupon-voucher__label">Your reward</span>

            <div class="quiz-coupon-voucher__code-frame">
              <span class="quiz-coupon-voucher__code-corner quiz-coupon-voucher__code-corner--tl" aria-hidden="true"></span>
              <span class="quiz-coupon-voucher__code-corner quiz-coupon-voucher__code-corner--tr" aria-hidden="true"></span>
              <span class="quiz-coupon-voucher__code-corner quiz-coupon-voucher__code-corner--bl" aria-hidden="true"></span>
              <span class="quiz-coupon-voucher__code-corner quiz-coupon-voucher__code-corner--br" aria-hidden="true"></span>
              <span id="quiz-coupon-code" class="quiz-coupon-voucher__code">${code}</span>
            </div>

            <button
              type="button"
              id="quiz-copy-code-btn"
              class="quiz-coupon-voucher__copy"
              data-copy-label="${copyLabel}"
              data-copied-label="${copiedLabel}"
              aria-label="Copy coupon code"
            >
              <span class="quiz-coupon-voucher__copy-icon" aria-hidden="true">
                <svg class="quiz-coupon-voucher__icon quiz-coupon-voucher__icon--copy" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <rect x="8" y="8" width="13" height="13" rx="2" stroke="currentColor" stroke-width="1.7"/>
                  <path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg class="quiz-coupon-voucher__icon quiz-coupon-voucher__icon--check" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M4 12.5l5 5L20 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="quiz-coupon-voucher__copy-text">${copyLabel}</span>
            </button>

            <div class="quiz-coupon-voucher__perforation" aria-hidden="true"></div>

            <p class="quiz-coupon-voucher__fineprint">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
                <path d="M8 12.5l2.5 2.5L16 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Apply at checkout</span>
            </p>
          </article>
        </div>

        <button type="button" id="quiz-view-results-btn" class="quiz-coupon-cta">
          <span class="quiz-coupon-cta__text">${ctaLabel}</span>
          <span class="quiz-coupon-cta__arrow" aria-hidden="true">
            <svg width="20" height="14" viewBox="0 0 24 16" fill="none">
              <path d="M2 8h20M16 2l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </section>
    `;

    const copyBtn  = root.querySelector('#quiz-copy-code-btn');
    const codeEl   = root.querySelector('#quiz-coupon-code');
    const viewBtn  = root.querySelector('#quiz-view-results-btn');
    const copyText = copyBtn ? copyBtn.querySelector('.quiz-coupon-voucher__copy-text') : null;

    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', async () => {
        const couponCode = (codeEl.textContent || '').trim();
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(couponCode);
          } else {
            const tempInput = document.createElement('input');
            tempInput.value = couponCode;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
          }
          copyBtn.classList.add('is-copied');
          if (copyText) copyText.textContent = copyBtn.dataset.copiedLabel || 'Copied';
          setTimeout(() => {
            copyBtn.classList.remove('is-copied');
            if (copyText) copyText.textContent = copyBtn.dataset.copyLabel || 'Copy';
          }, 1800);
        } catch (error) {
          console.warn('Coupon copy failed', error);
        }
      });
    }

    if (viewBtn) {
      viewBtn.addEventListener('click', () => {
        window.location.href = resultUrl;
      });
    }
  }

  function resolveResultUrl() {
    const configuredUrl = String((settings && settings.resultUrl) || '').trim();
    if (configuredUrl) return configuredUrl;
    // Fallback so quiz flow never breaks if setting is empty/malformed.
    return '/pages/quiz-result';
  }

  function persistQuizResultUrl(resultUrl) {
    try {
      window.sessionStorage.setItem('quiz_result_url', resultUrl);
      window.sessionStorage.setItem('quiz_result_saved_at', String(Date.now()));
    } catch (error) {
      console.warn('Quiz result URL persistence failed', error);
    }
  }

  function fillBucket(initialItems, minimumCount, excludedItems, fallbackPool) {
    const result = [...new Set(initialItems)].filter((p) => p && p.trim() !== '');
    const excluded = new Set(excludedItems);

    for (const item of result) excluded.add(item);

    for (const item of fallbackPool) {
      if (result.length >= minimumCount) break;
      if (excluded.has(item)) continue;
      result.push(item);
      excluded.add(item);
    }

    return result;
  }

  function buildKlaviyoProperties(answersData, quizConfig) {
    if (!quizConfig || !Array.isArray(quizConfig)) return {};
    const props = {};
    quizConfig.forEach((question, index) => {
      const answer = answersData[index];
      if (!answer || !answer.value || answer.value.length === 0) return;
      const key = (question.question || ('Quiz Q' + (index + 1)))
        .replace(/^\d+\.\s*/, '')
        .replace(/:\s*$/, '')
        .trim();
      props[key] = answer.value.join(', ');
    });
    return props;
  }

  function sendQuizAnswersToKlaviyo(email, answersData) {
    const publicKey = settings && settings.klaviyoPublicKey;
    if (!publicKey || !email) return;

    const properties = buildKlaviyoProperties(answersData, quizData);
    const couponCode = String(leadGate.couponCode || '').trim();
    if (couponCode) properties['Quiz Coupon Code'] = couponCode;

    const companyParam = '?company_id=' + encodeURIComponent(publicKey);
    const headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };

    // Call 1: Update profile custom properties explicitly
    fetch('https://a.klaviyo.com/client/profiles/' + companyParam, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: { email: email, properties: properties }
        }
      })
    }).catch(function(err) {
      console.warn('Klaviyo profile update failed:', err);
    });

    // Call 2: Create "Quiz Completed" event for tracking
    fetch('https://a.klaviyo.com/client/events/' + companyParam, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: properties
          }
        }
      })
    }).catch(function(err) {
      console.warn('Klaviyo event creation failed:', err);
    });
  }

  function buildQ2Options(baseOptions, imageCount) {
    const options = Array.isArray(baseOptions) ? [...baseOptions] : [];
    const totalSlots = Math.max(options.length, imageCount, 6);

    for (let i = options.length; i < totalSlots; i++) {
      options.push({
        label: `Option ${i + 1}`,
        value: `q2_option_${i + 1}`,
      });
    }

    return options;
  }

  /* ----------------------------------------------------------
     Boot
     Decide what to render based on whether the user just came
     back from a Shopify newsletter form submission.
  ---------------------------------------------------------- */
  const savedResultUrl = getSavedResultUrl();

  if (window.__quizEmailJustPosted && savedResultUrl) {
    // Newsletter form submitted successfully — Shopify created/updated
    // the customer with the subscriber tag. Skip the quiz and show the
    // coupon step directly.
    renderCouponStep(savedResultUrl);
  } else if (window.__quizEmailHasErrors && savedResultUrl) {
    // Form posted with errors (e.g. invalid email) — Liquid has already
    // rendered the lead gate with error messages. Reveal it and let
    // the user retry.
    const leadgate = document.getElementById('quiz-leadgate-container');
    if (leadgate) {
      if (root) root.style.display = 'none';
      leadgate.hidden = false;
      bindLeadGateActions(leadgate, savedResultUrl);
      scrollToLeadGate(leadgate);
    } else {
      initStickyVisibility();
      renderStep();
    }
  } else {
    initStickyVisibility();
    renderStep();
  }

  function getSavedResultUrl() {
    try {
      const saved = window.sessionStorage.getItem('quiz_result_url');
      const savedAtRaw = window.sessionStorage.getItem('quiz_result_saved_at');
      const savedAt = savedAtRaw ? parseInt(savedAtRaw, 10) : 0;
      const isFresh = savedAt && (Date.now() - savedAt < 15 * 60 * 1000);
      return isFresh && saved ? saved : null;
    } catch (err) {
      return null;
    }
  }

  /* ----------------------------------------------------------
     Sticky button visibility (Bug 3 fix)
     IntersectionObserver watches the quiz root element.
     Adds `quiz-in-view` on <html> when the quiz is visible
     so CSS can smoothly slide the fixed buttons in/out.
  ---------------------------------------------------------- */
  function initStickyVisibility() {
    if (typeof IntersectionObserver === 'undefined') {
      // Older browsers: always show buttons
      document.documentElement.classList.add('quiz-in-view');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        document.documentElement.classList.toggle(
          'quiz-in-view',
          entries[0].isIntersecting
        );
      },
      { threshold: 0.05 }  // trigger when ≥5% of quiz is visible
    );

    observer.observe(root);
  }
});
